import Dashboard from './components/Dashboard';
import { withProvider } from './dashboardStore';

export default withProvider(Dashboard);
